
import { designMode } from '@/env';
import { Component, Vue } from 'vue-property-decorator';
import { store } from '@/store';
import router from '@/router';
import Title from '@/views/setup/Title.vue';
import Step from '@/views/setup/Step.vue';
import { dispatchCheckLoggedIn, dispatchCheckSetupCompleted } from '@/store/main/actions';
import { dispatchRestoreSetup } from '@/store/setup/actions';
import { readIsLoggedIn, readIsSetupCompleted } from '@/store/main/getters';
import { toBoolean } from '@/utils';
import ApplicationFooter from '@/components/ApplicationFooter.vue';

const startRouteGuard = async (to, from, next) => {
  await dispatchCheckLoggedIn(store);
  if (readIsLoggedIn(store)) {
    await dispatchCheckSetupCompleted(store);
    if (readIsSetupCompleted(store)) {
      if (!(to.path as string).endsWith('/complete')) {
        next('/main');
      } else {
        next();
      }
    } else {
      if (to.redirectedFrom && (to.redirectedFrom as string).endsWith('/restore')) {
        dispatchRestoreSetup(store)
      }
      next();
    }
  } else {
    if ((to.path as string).startsWith('/setup')) {
      next('/login');
    } else {
      next();
    }
  }
};

@Component({
  components: {
    Step,
    Title,
    ApplicationFooter,
  },
})
export default class Setup extends Vue {
  public step = 0;

  public setStep(path) {
    if ((path as string).endsWith('/basic')) {
      this.step = 1;
    }
    else if ((path as string).endsWith('/product')) {
      this.step = 2;
    }
    else if ((path as string).endsWith('/finance')) {
      this.step = 3;
    } else {
      this.step = 0;
    }
  }

  public async mounted() {
    this.setStep(router.currentRoute.path);
  }

  public async updated() {
    this.setStep(router.currentRoute.path);
  }

  public beforeRouteEnter(to, from, next) {
    if ((from.path as string).endsWith('callback') || toBoolean(designMode)) {
      next();
    } else {
      startRouteGuard(to, from, next);
    }
  }

  public beforeRouteUpdate(to, from, next) {
    if ((from.path as string).endsWith('callback') || toBoolean(designMode)) {
      next();
    } else {
      startRouteGuard(to, from, next);
    }
  }
}
